import { CircularProgress } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import store from '../../../../core/redux/store';
import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';
import { TReport } from '../../definitions';
import { CreateReport } from '../components/report-create-button';
import ReportsItem from '../components/reports-item/reports-item';
import { getReportsAction } from '../redux/actions/reports-actions';
import { reportStyles } from './styles';

export default function ReportsListPage() {
  const classes = reportStyles();
  const dispatch = useDispatch();

  const state = store.getState();
  const token = state.token.token;

  const { reports, loading } = useSelector((state) => state.reports);

  useEffect(() => {
    if (!token) return;

    dispatch(getReportsAction(token));
  }, [token]);

  return (
    <>
      <CssBaseline />
      <Container className={classes.container}>
        <BackNavigationComponent page="Analytics Reports" uri="/" />
        {loading ? (
          <Grid container justify="center">
            <Grid item>
              <CircularProgress />
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2}>
            {reports.map((report: TReport) => (
              <Grid key={report.id} item xs={6}>
                <ReportsItem report={report} />
              </Grid>
            ))}
            <CreateReport />
          </Grid>
        )}
      </Container>
    </>
  );
}
